import React from 'react';

const PlayingCard = ({ card, size = 'md' }) => {
  // Parse card string (e.g., "As" = Ace of Spades, "Kh" = King of Hearts)
  const getSuitSymbol = (suit) => {
    const suits = {
      's': '♠',  // spades
      'h': '♥',  // hearts
      'd': '♦',  // diamonds
      'c': '♣'   // clubs
    };
    return suits[suit] || suit;
  };

  const getSuitColor = (suit) => {
    return ['h', 'd'].includes(suit) ? '#DC2626' : '#0B0F14';
  };

  const sizeClasses = {
    sm: 'w-12 h-16 text-lg',
    md: 'w-16 h-24 text-2xl',
    lg: 'w-20 h-28 text-3xl'
  };

  // Card back
  if (card === 'back') {
    return (
      <div className={`${sizeClasses[size]} bg-gradient-to-br from-[#B4232A] via-[#8B1A1F] to-[#5A0F13] border-2 border-[#C9A227]/30 rounded-lg shadow-lg flex items-center justify-center`}>
        <div className="w-8 h-8 border-2 border-[#C9A227]/40 rounded-full" />
      </div>
    );
  }

  if (!card || card.length < 2) return null;

  const rank = card[0].toUpperCase();
  const suit = card[1].toLowerCase();
  const suitSymbol = getSuitSymbol(suit);
  const suitColor = getSuitColor(suit);

  return (
    <div
      className={`
        ${sizeClasses[size]} 
        bg-white rounded-lg shadow-lg border-2 border-zinc-300 
        flex flex-col items-center justify-center
        relative overflow-hidden
      `}
      data-testid={`card-${card}`}
    >
      {/* Rank (top-left) */}
      <div className="absolute top-1 left-1 flex flex-col items-center leading-none">
        <span className="font-bold" style={{ color: suitColor }}>
          {rank}
        </span>
        <span className="text-sm" style={{ color: suitColor }}>
          {suitSymbol}
        </span>
      </div>

      {/* Center symbol */}
      <span className="font-bold" style={{ color: suitColor, fontSize: 'inherit' }}>
        {suitSymbol}
      </span>

      {/* Rank (bottom-right, rotated) */}
      <div className="absolute bottom-1 right-1 flex flex-col items-center leading-none rotate-180">
        <span className="font-bold" style={{ color: suitColor }}>
          {rank}
        </span>
        <span className="text-sm" style={{ color: suitColor }}>
          {suitSymbol}
        </span>
      </div>
    </div>
  );
};

export default PlayingCard;